import {NewAboutI18n} from '@/locales/base.message.locales';

export const newAboutI18n: NewAboutI18n = {
  section_13: {
    p4: 'It is a symbolic type name, connecting with the causes represented and <br/> the agents that get involved as an example for others.',
    p1: 'The word <strong>Ikone is derived from the Greek, (eikon, image).</strong>',
    p2: 'In the field of <strong>religious art</strong> it identifies a <strong>sacred representation.</strong>',
    p3: 'In the field of <strong>psychology</strong>, an icon is an image that<strong>represents something.</strong>',
    title: '<strong>A movement<br> that unlocks, removes <br> axis and make it happen.</strong>'
  },
  section_12: {
    p: 'in social impact actions through a decentralized global movement through open innovation with online challenge platform and impact actions in the real world.',
    title: 'We want to reach the equivalent of 1 billion people in the world'
  },
  section_11: {
    p1: `<strong>IKONE addresses the Great Challenges of the world<strong>,
    creating and managing a multiple platform, physical and virtual,
    to connect entrepreneurs, companies and government to solve
    complex social challenges of poor and emerging communities,
    multiplying impact export solutions to other parts of the world.`,
    p2: `<strong>As matchmakers, we are part of the social league - a living lab - a real-world environment.</strong>`,
    p3: `Where do we start? How do we begin to respond to
 this great challenge? We think we should start from
 scratch on virgin lands to build this special kind of new community.`,
    p4: `This Living Lab is an invitation to the
 ideals, dreams and solutions to the
 challenges of the social complex
 present in the communities of 3.5
 billion people - the poorest half
 of the world's population.`,
    p5: `From startups to large corporations, everyone need
to test and demonstrate apps like 3D printing for
housing, digital AI for twins for health prevention,
 blockchain to transform public governance,
 VR and AR to elevate education, computer analysis
 for better security and all innovations to leverage
 this living laboratory.`,
    p6: `Most importantly, when we find the need for solutions
 and social technologies that do not yet exist, it is our
 hope that IKONE will encourage citizens around the world to
 develop new solutions in their own communities.
 Solutions that will meet the needs of the people expressed
  in this experimental community.`,
    title: 'LIVING LAB'
  },
  section_10: {
    p1: `We believe that it is necessary to donate,
    and we will facilitate the awakening of
    talents and connect with social initiatives
    with global impact, to do good in a contagious  multiplying results.`,
    p2: '<strong>DON\'T JUST DONATE. YOU NEED TO DONATE YOURSELF.\n</strong>',
    p3: `Our social initiatives will give hope to
thousands of people to fight health problems,
benefit from education and break the cycle
of poverty by creating positive and lasting change.`
  },

  section_9: {
    p1: 'Social Impact Investment Fund',
    p2: 'Monitoring and Evaluations',
    p3: 'Results (SOCIAL IRR)',
    p4: 'Global Partnerships',
    title: 'FOCUS ON LASTING RESULTS'
  },
  section_8: {
    p1: `We link High Impact Projects, <br/>  Opportunities to Transform to a network <br/> of Local Talents.`,
    p2: `We enter into partnerships with the most effective and comprehensive
 global organizations that enable human and financial resources.</strong>`,
    p3: `IKONE connects with the best local professionals (on the
                    ground) to focus our resources on critical problems, delivering
                     results on a scale that few can achieve alone,
                    we seek a SOCIAL IRR, a rate of return on investment that
                    can increase investments made up to 20x.`
  },

  section_7: {
    p1w1: '<strong>Link</strong>',
    p1w2: '<span>High Impact<br> Projects</span>',
    p2w1: '<strong>Integrate</strong>',
    p2w2: '<span>Opportunities <br> to Transform</span> ',
    p3w1: '<strong>Connect</strong>',
    p3w2: '<span>Network of <br/>Local Talents.</span>'
  },

  section_6: {
    p1: `We are a social league that makes
                sense when fosters more prosperous
                and autonomous communities.`,
    p2: ` <strong>
                  We are Ikone, synonymous of vocation for facilitate
                  an urgent, positive and lasting change that
                  transforms the lives of our land.
                </strong>`
  },

  section_5: {
    p1: `We promote innovation
                  by mapping projects and causes
                  that need to happen.`,
    p2: `We are committed to mobilizing a network of
                    local talent and global partnerships to on
                    a large scale and with high impact what many
                    consider it impossible.`
  },
  section_4: {
    p1: `We grew up with anxiety and awareness that the
 challenges are enormous, involve
 attempts where much is lost and the feeling of
 helplessness discourages action.`,
    p2: `We are resilient and connectors. We multiply results and we make the future where everyone wins.`
  },

  section_3: {
    p1: `<strong>We were born</strong><br>
                to show<br>
                that <strong>it works.</strong>`
  },

  section_2: {
    p1: `The <strong>Movement</strong> <br>
                  that must <br>
                  <strong>happen.</strong>`,
    p2: `IKONE is a organization whose goal is to bring together
     a global social league of innovators, entrepreneurs and investors
      united to fight poverty and create prosperity.`,
    p3: `To deal with such a critical and break the cycle of poverty,
     we put our knowledge and we adopt effective social
      programs within the UN Sustainable Development Goals.`
  },

  section_1: {title: 'WE ARE A GLOBAL SOCIAL LEAGUE\n'},

}
